export default defineNuxtPlugin(() => {
  const { $domain, $config } = useNuxtApp();

  if ($config.public.usercentricsId) {
    const lang = $domain.locales?.[0].split('-')?.[0];
    if (!lang) {
      throw new Error('No language found for Usercentrics CMP');
    }

    useHead({
      script: [
        {
          'fetchpriority': 'high',
          'data-version': 'preview',
          'data-tcf-enabled': true,
          'data-settings-id': $config.public.usercentricsId as string,
          'data-language': lang,
          'data-avoid-prefetch-services': '',
          'defer': true,
          'async': true,
          'id': 'usercentrics-cmp',
          'src': 'https://app.usercentrics.eu/browser-ui/latest/loader.js',
        },
      ],
    });
  }
});
